import { PersonService } from 'data/services';
import { PersonServiceInterface } from 'domain/services';
import { makeRemoteActivateInactivatePerson } from 'main/factories/usecases/person/activate-inactivate-person-factory';
import { makeRemoteGetAllPersonActivities } from 'main/factories/usecases/person/activities/get-all-person-activities-factory';
import { makeRemoteChangePersonPassword } from 'main/factories/usecases/person/change-person-password-factory';
import { makeRemoteDeleteCompletedEvaluation } from 'main/factories/usecases/person/completed-evaluations/delete-completed-evaluation-factory';
import { makeRemoteGetAllPersonCompletedEvaluations } from 'main/factories/usecases/person/completed-evaluations/get-all-person-completed-evaluations-factory';
import { makeRemoteGetCompletedEvaluationDetails } from 'main/factories/usecases/person/completed-evaluations/get-completed-evaluation-details-factory';
import { makeRemoteGetAllPerson } from 'main/factories/usecases/person/get-all-person-factory';
import { makeRemoteGetAllPersonOverviewIndicators } from 'main/factories/usecases/person/get-all-person-overview-indicators-factory';
import { makeRemoteGetAllPersonProfile } from 'main/factories/usecases/person/get-all-person-profile-factory';
import { makeRemoteGetByIdPerson } from 'main/factories/usecases/person/get-by-id-person-factory';
import { makeRemoteGetPersonByIdV2 } from 'main/factories/usecases/person/get-person-by-id-v2-factory';
import { makeRemoteActivateInactivatePersonProfile } from 'main/factories/usecases/person/profile/activate-inactivate-person-profile-factory';
import { makeRemoteChangePasswordProfile } from 'main/factories/usecases/person/profile/change-password-profile-factory';
import { makeRemoteProfileGetById } from 'main/factories/usecases/person/profile/profile-get-by-id-factory';
import { makeRemoteProfileUpdate } from 'main/factories/usecases/person/profile/profile-update-factory';
import { makeRemoteUpdatePerson } from 'main/factories/usecases/person/update-person-factory';
import { makeRemoteGetAllPersonValidatedActivities } from 'main/factories/usecases/person/validated-activities/get-all-person-validated-activities-factory';

export const makePersonService = (): PersonServiceInterface => {
  return new PersonService({
    getAllPerson: makeRemoteGetAllPerson(),
    getByIdPerson: makeRemoteGetByIdPerson(),
    getAllPersonProfile: makeRemoteGetAllPersonProfile(),
    updateProfile: makeRemoteProfileUpdate(),
    getByIdProfile: makeRemoteProfileGetById(),
    changePasswordProfile: makeRemoteChangePasswordProfile(),
    updatePerson: makeRemoteUpdatePerson(),
    changePersonPassword: makeRemoteChangePersonPassword(),
    activateInactivatePerson: makeRemoteActivateInactivatePerson(),
    activateInactivatePersonProfile:
      makeRemoteActivateInactivatePersonProfile(),
    getAllPersonOverviewIndicators: makeRemoteGetAllPersonOverviewIndicators(),
    getPersonByIdV2: makeRemoteGetPersonByIdV2(),
    getAllPersonActivities: makeRemoteGetAllPersonActivities(),
    getAllPersonValidatedActivities:
      makeRemoteGetAllPersonValidatedActivities(),
    getAllPersonCompletedEvaluations:
      makeRemoteGetAllPersonCompletedEvaluations(),
    getCompletedEvaluationDetails: makeRemoteGetCompletedEvaluationDetails(),
    deleteCompletedEvaluation: makeRemoteDeleteCompletedEvaluation(),
  });
};
